import api from 'api'
import { z } from 'zod'

const w2StatusRequest = z.object({
  userId: z.string(),
})

const w2StatusResponse = z.object({
  w2Status: z.string().nullable().optional(),
  i9Status: z.string().nullable().optional(),
  i9InquiryId: z.string().nullable().optional(),
  i9InquiryStatus: z.string().nullable().optional(),
})

export const getUserW2Status = async (
  request: z.infer<typeof w2StatusRequest>
) => {
  const { userId } = w2StatusRequest.parse(request)

  const result = await api.get<{
    data: z.infer<typeof w2StatusResponse>
  }>(`/admin/user/${userId}/w2/status`)

  return w2StatusResponse.parse(result.data)
}
